import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import LocationLockingDto from '../entities/location-locking/locationlocking';

interface LocationLockingState extends ListState<LocationLockingDto>{
    // transportTypes :[],
    // transportStatuses:[],
    // binTypes:[],
    // rooms:[],
    // aisles:[]
}
class LocationLockingMutations extends ListMutations<LocationLockingDto>{

}
class LocationLockingModule extends ListModule<LocationLockingState,any,LocationLockingDto>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<LocationLockingDto>(),
        loading:false,
        // transportTypes :new Array<any>(),
        // transportStatuses:new Array<any>(),
        // binTypes:new Array<any>(),
        // rooms:new Array<any>(),
        // aisles:new Array<any>()
    }
    actions={
        async getAll(context:ActionContext<LocationLockingState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/LocationLocking/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<LocationLockingDto>;
            context.state.totalCount=page.totalCount;
            context.state.list= page.items;
        },
        async get(context:ActionContext<LocationLockingState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/LocationLocking/GetDetail?Id='+payload.data.id);
            return reponse.data.result;
        },
        async searchBins(context:ActionContext<LocationLockingState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/LocationLocking/searchBins',{params:payload.data});
            return reponse.data.result;
        },
        async searchTransports(context:ActionContext<LocationLockingState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/LocationLocking/searchTransports',{params:payload.data});
            return reponse.data.result;
        },
        async unlock(context:ActionContext<LocationLockingState,any>,payload:any){
            let reponse=await Ajax.put('/api/services/app/LocationLocking/UnLock',payload.data);
          //  return reponse.data.result;
        },
        async create(context: ActionContext<LocationLockingState, any>, payload: any) {
            let response= await Ajax.post('/api/services/app/LocationLocking/Create', payload.data);
            return response.data.result;
        },
       
        async getLocationTypes(context:ActionContext<LocationLockingState,any>, payload: any){
            let reponse=await Ajax.get('/api/services/app/LocationLocking/GetLocationTypes',{params:payload.data});
            return reponse.data.result;
        },
    };
    mutations={
        setCurrentPage(state:LocationLockingState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:LocationLockingState,pagesize:number){
            state.pageSize=pagesize;
        },
        // setTransportTypes(state:LocationLockingState, types:[])
        // {
        //     state.transportTypes = types;
        // },
        // setTransportStatuses(state:LocationLockingState, statuses:[])
        // {
        //     state.transportStatuses = statuses;
        // },
        // setBinTypes(state:LocationLockingState, types:[])
        // {
        //     state.binTypes = types;
        // },
        // setRooms(state:LocationLockingState, rooms:[])
        // {
        //     state.rooms = rooms;
        // },
        // setAisles(state:LocationLockingState, aisles:[])
        // {
        //     state.aisles = aisles;
        // }
    }
}
const locationLockingModule=new LocationLockingModule();
export default locationLockingModule;